import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow p-6" }
const _hoisted_2 = { class: "flex justify-between items-center mb-4" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center items-center py-12"
}
const _hoisted_6 = {
  key: 1,
  class: "bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative mb-6"
}
const _hoisted_7 = { class: "block sm:inline" }
const _hoisted_8 = {
  key: 3,
  class: "space-y-4"
}
const _hoisted_9 = { class: "md:flex items-center" }
const _hoisted_10 = { class: "flex-grow" }
const _hoisted_11 = { class: "font-medium" }
const _hoisted_12 = {
  key: 0,
  class: "text-gray-500 text-sm"
}
const _hoisted_13 = { class: "flex-shrink-0 mx-2 text-center" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "flex-shrink-0 mx-2 text-center" }
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { class: "flex-shrink-0 mx-2" }
const _hoisted_18 = { class: "flex-shrink-0 ml-2" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "w-24"
}
const _hoisted_21 = { class: "flex-shrink-0 ml-2" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "mt-4 pt-4 border-t border-gray-200"
}
const _hoisted_24 = { class: "flex justify-between items-start mb-3" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = { class: "font-medium" }
const _hoisted_27 = {
  key: 0,
  class: "text-gray-500 text-sm"
}
const _hoisted_28 = { class: "grid grid-cols-2 gap-2 mb-3 text-sm text-gray-600" }
const _hoisted_29 = { class: "flex justify-between items-center" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "mt-4 pt-4 border-t border-gray-200"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_CommentList = _resolveComponent("CommentList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-xl font-semibold" }, "Report Overview", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("label", {
          for: "quarter-select",
          class: "mr-2 text-sm text-gray-500"
        }, "Select Quarter:", -1)),
        _withDirectives(_createElementVNode("select", {
          id: "quarter-select",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedQuarter) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onQuarterChange && _ctx.onQuarterChange(...args))),
          class: "border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableQuarters, (quarter) => {
            return (_openBlock(), _createElementBlock("option", {
              key: quarter.value,
              value: quarter.value
            }, _toDisplayString(quarter.label), 9, _hoisted_4))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.selectedQuarter]
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary" }, null, -1)
        ])))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("strong", { class: "font-bold" }, "Error:", -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.error.message), 1)
          ]))
        : (_ctx.reports.length === 0)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 2,
              icon: "document",
              title: "No templates found",
              message: "There are no forecasting templates available for the selected quarter."
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (report) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: report.id,
                  class: "border border-gray-200 rounded-lg p-4 hidden md:block"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-shrink-0 mr-4" }, [
                      _createElementVNode("div", { class: "text-blue-600" }, [
                        _createElementVNode("svg", {
                          class: "h-6 w-6",
                          fill: "currentColor",
                          viewBox: "0 0 20 20",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z",
                            "clip-rule": "evenodd"
                          })
                        ])
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("h3", _hoisted_11, _toDisplayString(report.report_name), 1),
                      (_ctx.getDocumentDate(report.document_id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.getDocumentDate(report.document_id)?.type) + ": " + _toDisplayString(_ctx.getDocumentDate(report.document_id)?.date), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(report.quarter), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatDate(report.due_date)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["px-2 py-1 text-xs rounded-full", _ctx.getStatusClass(report.status)])
                      }, _toDisplayString(report.status), 3)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (report.status === _ctx.DOCUMENT_STATUS.READY_FOR_DOWNLOAD || report.status === _ctx.DOCUMENT_STATUS.DOWNLOADED)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass(report.status === _ctx.DOCUMENT_STATUS.DOWNLOADED
      ? 'border border-blue-600 text-blue-600 bg-transparent px-4 py-2 rounded-md text-sm flex items-center'
      : 'bg-blue-600 text-white px-4 py-2 rounded-md text-sm flex items-center'),
                            onClick: ($event: any) => (_ctx.downloadTemplate(report.template_id))
                          }, _cache[6] || (_cache[6] = [
                            _createElementVNode("svg", {
                              class: "h-4 w-4 mr-1",
                              fill: "currentColor",
                              viewBox: "0 0 20 20",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                                "clip-rule": "evenodd"
                              })
                            ], -1),
                            _createTextVNode(" Download ")
                          ]), 10, _hoisted_19))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20))
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("button", {
                        class: "text-gray-400 hover:text-gray-600",
                        onClick: ($event: any) => (_ctx.toggleComments(report.document_id))
                      }, _cache[7] || (_cache[7] = [
                        _createElementVNode("svg", {
                          class: "h-5 w-5",
                          fill: "currentColor",
                          viewBox: "0 0 20 20",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                            "clip-rule": "evenodd"
                          })
                        ], -1)
                      ]), 8, _hoisted_22)
                    ])
                  ]),
                  (_ctx.expandedReportId === report.document_id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_CommentList, {
                          referenceId: report.document_id
                        }, null, 8, ["referenceId"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (report) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `mobile-${report.id}`,
                  class: "border border-gray-200 rounded-lg p-4 md:hidden"
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-blue-600 mr-2" }, [
                        _createElementVNode("svg", {
                          class: "h-5 w-5",
                          fill: "currentColor",
                          viewBox: "0 0 20 20",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z",
                            "clip-rule": "evenodd"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", _hoisted_26, _toDisplayString(report.report_name), 1),
                        (_ctx.getDocumentDate(report.document_id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.getDocumentDate(report.document_id)?.type) + ": " + _toDisplayString(_ctx.getDocumentDate(report.document_id)?.date), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["px-2 py-1 text-xs rounded-full", _ctx.getStatusClass(report.status)])
                    }, _toDisplayString(report.status), 3)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "font-medium" }, "Quarter:", -1)),
                      _createTextVNode(" " + _toDisplayString(report.quarter), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "font-medium" }, "Due:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.formatDate(report.due_date)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("button", {
                      class: "text-gray-400 hover:text-gray-600",
                      onClick: ($event: any) => (_ctx.toggleComments(report.document_id))
                    }, _cache[12] || (_cache[12] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5",
                        fill: "currentColor",
                        viewBox: "0 0 20 20",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                          "clip-rule": "evenodd"
                        })
                      ], -1)
                    ]), 8, _hoisted_30),
                    _createElementVNode("div", null, [
                      (report.status === _ctx.DOCUMENT_STATUS.READY_FOR_DOWNLOAD)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "bg-blue-600 text-white px-3 py-1 rounded-md text-sm flex items-center",
                            onClick: ($event: any) => (_ctx.downloadTemplate(report.template_id))
                          }, _cache[13] || (_cache[13] = [
                            _createElementVNode("svg", {
                              class: "h-4 w-4 mr-1",
                              fill: "currentColor",
                              viewBox: "0 0 20 20",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                                "clip-rule": "evenodd"
                              })
                            ], -1),
                            _createTextVNode(" Download ")
                          ]), 8, _hoisted_31))
                        : (report.status === _ctx.DOCUMENT_STATUS.ADJUSTMENT_NEEDED)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "bg-purple-600 text-white px-3 py-1 rounded-md text-sm flex items-center",
                              onClick: ($event: any) => (_ctx.reviewReport(report.id))
                            }, _cache[14] || (_cache[14] = [
                              _createElementVNode("svg", {
                                class: "h-4 w-4 mr-1",
                                fill: "currentColor",
                                viewBox: "0 0 20 20",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", { d: "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" })
                              ], -1),
                              _createTextVNode(" Review ")
                            ]), 8, _hoisted_32))
                          : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.expandedReportId === report.document_id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createVNode(_component_CommentList, {
                          referenceId: report.document_id
                        }, null, 8, ["referenceId"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
  ]))
}